import React from 'react'

const ALMReportNavUI = ({
    selectedTab,
    setSelectedTab
}) =>
    <div>
        <div className='g_flex_h g_flex_left g_flex_wrap'>

            <span
                className={`w_tab g_muted ${selectedTab === 'goodStanding' ? 'active' : ''}`}
                onClick={() => setSelectedTab('goodStanding')}
            >
                Good Standing Accounts
            </span>

            <span
                className={`w_tab g_muted ${selectedTab === 'allAccounts' ? 'active' : ''}`}
                onClick={() => setSelectedTab('allAccounts')}
            >
                All Accounts
            </span>

        </div>

        <div className='g_m_top_50' />
    </div>

export default ALMReportNavUI